export function checkIsEmptyData(data){return!data||data==='0x';}